module.exports = __webpack_public_path__ + "9e28a5a7f2e469dd0a5efe6262906235.jpg";


//////////////////
// WEBPACK FOOTER
// ./res/images/backgrounds/en/stingray_music.jpg
// module id = 860
// module chunks = 0